module.exports = __webpack_public_path__ + "img/drh5_share_kr.04ef70a4.png";